
(function(){
'use strict';
var D=document,cfg=window.themeConfig||{root:'/',cartUrl:'/cart',allUrl:'/collections/all',currency:'USD',locale:'en',cartType:'drawer'};
function $(s,c){return (c||D).querySelector(s)}
function $$(s,c){return Array.prototype.slice.call((c||D).querySelectorAll(s))}
var fmt=null;try{fmt=new Intl.NumberFormat(cfg.locale,{style:'currency',currency:cfg.currency})}catch(e){}
function money(c){return fmt?fmt.format(c/100):(c/100).toFixed(2)}
function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(m){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]})}

/* scroll reveal */
var io=('IntersectionObserver' in window)?new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px',threshold:.06}):null;
function watch(scope){$$('[data-reveal]:not(.is-in)',scope).forEach(function(el){if(io)io.observe(el);else el.classList.add('is-in')})}
watch();

/* sticky header shadow */
var hdr=$('[data-header]');
function onScroll(){if(hdr)hdr.classList.toggle('is-stuck',window.scrollY>10)}
window.addEventListener('scroll',onScroll,{passive:true});onScroll();

/* layers: menu, cart, filters */
var scrim=$('[data-scrim]'),openEl=null;
function openLayer(el){if(!el)return;closeLayer();el.classList.add('is-open');el.setAttribute('aria-hidden','false');scrim.classList.add('is-on');D.body.classList.add('no-scroll');openEl=el}
function closeLayer(){if(!openEl)return;openEl.classList.remove('is-open');openEl.setAttribute('aria-hidden','true');scrim.classList.remove('is-on');D.body.classList.remove('no-scroll');openEl=null}
scrim.addEventListener('click',closeLayer);
D.addEventListener('keydown',function(e){if(e.key==='Escape')closeLayer()});
D.addEventListener('click',function(e){
  var t=e.target;
  if(t.closest('[data-menu-open]')){openLayer($('[data-mnav]'));return}
  if(t.closest('[data-filter-open]')){openLayer($('[data-filters-panel]'));return}
  if(t.closest('[data-close]')){closeLayer();return}
  var co=t.closest('[data-cart-open]');
  if(co&&cfg.cartType==='drawer'&&$('[data-cart-drawer]')){e.preventDefault();openLayer($('[data-cart-drawer]'));return}
  var q=t.closest('[data-q]');
  if(q){changeLine(q.getAttribute('data-key'),parseInt(q.getAttribute('data-q'),10));return}
});

/* cart */
function renderCart(cart){
  $$('[data-cart-count]').forEach(function(n){n.textContent=cart.item_count;n.classList.toggle('is-zero',cart.item_count===0);n.classList.remove('bump');void n.offsetWidth;n.classList.add('bump')});
  $$('[data-cart-num]').forEach(function(n){n.textContent=cart.item_count});var box=$('[data-cart-items]');if(!box)return;
  if(!cart.items.length){box.innerHTML='<div class="cdr__empty"><p>Your cart is empty.</p><a class="btn" href="'+esc(cfg.allUrl)+'">Start shopping</a></div>'}
  else{box.innerHTML=cart.items.map(function(it){
    var img=it.image?it.image+(it.image.indexOf('?')>-1?'&':'?')+'width=200':'';
    var v=(it.variant_title&&it.variant_title!=='Default Title')?'<span class="muted">'+esc(it.variant_title)+'</span>':'';
    return '<div class="citem"><a class="citem__img" href="'+esc(it.url)+'">'+(img?'<img src="'+esc(img)+'" alt="'+esc(it.product_title)+'" loading="lazy">':'')+'</a>'+
    '<div class="citem__info"><a class="citem__t" href="'+esc(it.url)+'">'+esc(it.product_title)+'</a>'+v+'<span>'+money(it.final_price)+'</span>'+
    '<div class="citem__row"><div class="mini"><button type="button" data-q="'+(it.quantity-1)+'" data-key="'+esc(it.key)+'" aria-label="Decrease">&minus;</button><span>'+it.quantity+'</span><button type="button" data-q="'+(it.quantity+1)+'" data-key="'+esc(it.key)+'" aria-label="Increase">+</button></div>'+
    '<button type="button" class="linkbtn" data-q="0" data-key="'+esc(it.key)+'">Remove</button></div></div><strong>'+money(it.final_line_price)+'</strong></div>'}).join('')}
  var f=$('[data-cart-foot]');if(f){f.hidden=!cart.items.length;var t=$('[data-cart-total]');if(t)t.textContent=money(cart.total_price)}
}
function getCart(){return fetch(cfg.root+'cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()})}
function changeLine(key,qty){
  fetch(cfg.root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json()}).then(renderCart)
}
D.addEventListener('submit',function(e){
  var f=e.target;if(!f.matches||!f.matches('form[data-ajax-add]'))return;
  e.preventDefault();
  var btn=$('button[type=submit]',f),err=$('[data-form-error]',f),old=btn?btn.innerHTML:'';
  if(err)err.hidden=true;if(btn){btn.disabled=true;btn.style.opacity='.7'}
  fetch(cfg.root+'cart/add.js',{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest',Accept:'application/json'},body:new FormData(f)})
  .then(function(r){return r.json().then(function(d){return {ok:r.ok,d:d}})})
  .then(function(res){
    if(!res.ok){if(err){err.textContent=res.d.description||res.d.message||'Could not add this item.';err.hidden=false}return}
    return getCart().then(function(c){renderCart(c);if(cfg.cartType==='page'){location.href=cfg.cartUrl}else{openLayer($('[data-cart-drawer]'))}})
  }).catch(function(){f.submit()})
  .then(function(){if(btn){btn.disabled=false;btn.style.opacity='';btn.innerHTML=old}});
});

/* buy now: add then go straight to checkout */
D.addEventListener('click',function(e){
  var b=e.target.closest('[data-buy-now]');if(!b)return;
  var f=b.closest('form');if(!f)return;e.preventDefault();
  var err=$('[data-form-error]',f),old=b.textContent;
  if(err)err.hidden=true;b.disabled=true;b.textContent='Please wait...';
  fetch(cfg.root+'cart/add.js',{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest',Accept:'application/json'},body:new FormData(f)})
  .then(function(r){return r.json().then(function(d){return {ok:r.ok,d:d}})})
  .then(function(res){
    if(!res.ok){b.disabled=false;b.textContent=old;if(err){err.textContent=res.d.description||res.d.message||'Could not add this item.';err.hidden=false}return}
    location.href=cfg.root+'checkout';
  }).catch(function(){b.disabled=false;b.textContent=old});
});

/* filters auto-apply */
$$('form[data-filters]').forEach(function(f){f.addEventListener('change',function(){f.submit()})});

/* product page */
$$('[data-product]').forEach(function(sec){
  var jd=$('[data-product-json]',sec);if(!jd)return;
  var p=JSON.parse(jd.textContent),form=$('form[data-ajax-add]',sec),idIn=$('[name=id]',form),priceEl=$('[data-price]',sec),btn=$('[data-add]',sec),track=$('[data-track]',sec);
  function selected(){return $$('.opt',sec).map(function(fs){var c=$('input:checked',fs);return c?c.value:null})}
  function find(){var s=selected();return p.variants.filter(function(v){return v.options.every(function(o,i){return !s.length||o===s[i]})})[0]}
  function toMedia(id){var s=$('[data-media-id="'+id+'"]',sec);if(s&&track)track.scrollTo({left:s.offsetLeft,behavior:'smooth'})}
  function update(){
    var v=find();
    if(!v){btn.disabled=true;btn.textContent='Unavailable';return}
    idIn.value=v.id;
    priceEl.innerHTML='<span class="now">'+money(v.price)+'</span>'+(v.compare_at_price>v.price?'<s>'+money(v.compare_at_price)+'</s><span class="badge">Sale</span>':'');
    btn.disabled=!v.available;btn.textContent=v.available?'Add to cart':'Sold out';var nb=$('[data-buy-now]',sec);if(nb)nb.disabled=!v.available;
    if(history.replaceState)history.replaceState(null,'','?variant='+v.id);
    if(v.featured_media)toMedia(v.featured_media.id);
  }
  $$('.opt input',sec).forEach(function(i){i.addEventListener('change',update)});
  $$('[data-qty]',sec).forEach(function(b){b.addEventListener('click',function(){var q=$('[name=quantity]',sec);q.value=Math.max(1,(parseInt(q.value,10)||1)+parseInt(b.getAttribute('data-qty'),10))})});
  $$('[data-thumb]',sec).forEach(function(t){t.addEventListener('click',function(){toMedia(t.getAttribute('data-thumb'));$$('[data-thumb]',sec).forEach(function(x){x.classList.toggle('is-on',x===t)})})});
  if(track){var tm;track.addEventListener('scroll',function(){clearTimeout(tm);tm=setTimeout(function(){var i=Math.round(track.scrollLeft/track.clientWidth);$$('[data-thumb]',sec).forEach(function(x,n){x.classList.toggle('is-on',n===i)})},80)},{passive:true})}
});

/* recommendations */
$$('[data-recs]').forEach(function(el){
  var u=el.getAttribute('data-url');if(!u)return;
  fetch(u).then(function(r){return r.text()}).then(function(t){
    var h=D.createElement('div');h.innerHTML=t;var n=$('[data-recs]',h);
    if(n&&n.innerHTML.trim()){el.innerHTML=n.innerHTML;watch(el)}
  }).catch(function(){});
});
})();
